import { render, staticRenderFns } from "./RoomControl.vue?vue&type=template&id=f4c823a8&scoped=true&"
import script from "./RoomControl.vue?vue&type=script&lang=js&"
export * from "./RoomControl.vue?vue&type=script&lang=js&"
import style0 from "./RoomControl.vue?vue&type=style&index=0&id=f4c823a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c823a8",
  null
  
)

export default component.exports